module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik03Ljk5OTA3IDguOTE5MjNMMTEuMDc1IDExLjk5NTFMMTEuOTk0MiAxMS4wNzU5TDguOTE4MzEgNy45OTk5OUwxMS45OTQyIDQuOTI0MDlMMTEuMDc1IDQuMDA0ODVMNy45OTkwNyA3LjA4MDc1TDQuOTIzMTQgNC4wMDQ4Mkw0LjAwMzkxIDQuOTI0MDZMNy4wNzk4MyA3Ljk5OTk5TDQuMDAzOTEgMTEuMDc1OUw0LjkyMzE0IDExLjk5NTJMNy45OTkwNyA4LjkxOTIzWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC45Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/jcxy-dialog/assets/close_icon.svg
// module id = BKZN
// module chunks = 33